import { MenuConfig, CommonConditions } from '@app/_interfaces/menu-config.interface';

/**
 * Menu Configuration for Habit Action Screen
 *
 * This defines all menu actions available on the daily habit entry screen.
 * Actions are ordered by priority (lower = higher priority = shown first on top bar).
 *
 * Responsive behavior:
 * - Desktop (>= 1024px): Close, Comments, Kebab (up to 5 total if more added)
 * - Tablet (>= 768px): Close, Comments, Kebab (up to 4 total if more added)
 * - Mobile (< 375px): Close, Kebab only
 *
 * Usage:
 * - To reorder: Change priority values
 * - To add action: Add new MenuAction to actions array
 * - To remove action: Remove from actions array
 */
export const HABIT_ACTION_MENU: MenuConfig = {
  featureType: 'habit',
  screenType: 'action',
  actions: [
    // ========================================
    // TOP BAR ACTIONS (Priority 1-5)
    // ========================================

    {
      id: 'close',
      icon: 'close',
      label: 'common_close',
      priority: 1,
      action: 'closeDialog',
      minScreenWidth: 0, // Always visible
    },

    {
      id: 'comments',
      icon: 'comment',
      label: 'comments_titleTopBar',
      priority: 2,
      action: 'openComments',
      condition: CommonConditions.NOT_DELETED,
      minScreenWidth: 375, // Hidden on mobile (< 375px), goes to kebab menu
    },

    {
      id: 'kebab',
      icon: 'more',
      label: 'common_more',
      priority: 3,
      action: 'openKebabMenu',
      condition: CommonConditions.NOT_DELETED,
      minScreenWidth: 0, // Always visible when not deleted
      customClass: 'more-icon',
    },

    // ========================================
    // KEBAB MENU ONLY ACTIONS
    // These NEVER appear on top bar, always in kebab menu
    // Order: Comment (overflow from top bar), then Edit Setup (10), Reset Entry (11), Delete Entry (12), Delete All Invalid (13)
    // ========================================

    {
      id: 'editSetup',
      icon: 'edit',
      label: 'actionCommon_editSetup',
      priority: 10,
      action: 'editSetup',
      kebabOnly: true,
    },

    {
      id: 'resetEntry',
      icon: 'reset',
      label: 'common_resetEntry',
      priority: 11,
      action: 'resetHabit',
      condition: CommonConditions.NOT_VIEWER,
      destructive: true,
      kebabOnly: true,
    },

    {
      id: 'deleteEntry',
      icon: 'trash',
      label: 'common_deleteEntry',
      priority: 12,
      action: 'deleteHabit',
      condition: (ctx) => ctx.role() === 'owner' && !ctx.isValidEntry(),
      destructive: true,
      kebabOnly: true,
    },

    {
      id: 'deleteAllInvalid',
      icon: 'trash',
      label: 'common_deleteAllInvalidEntries',
      priority: 13,
      action: 'deleteAllInvalidEntries',
      condition: (ctx) => ctx.role() === 'owner' && !ctx.isValidEntry(),
      destructive: true,
      kebabOnly: true,
    },
  ],
};
